// extracted by mini-css-extract-plugin
export default {"rating":"yA-z","numberOfStars":"zA-z","count":"AA-z","barGraphSpacing":"BA-z","barGraph":"CA-z"};